// @flow
import type { Action } from "../actions/types";
import {
  SESSION_CHECKED_SUCCESS,
  RESET_CHECK_SESSION,
  SESSION_CHECKED_ERROR,
  LOGIN_ERROR,
  INITIATE_LOGIN,
  LOGIN_SUCCESS,
  SET_SESSION_ID,
  INITIATE_REQUEST_OTP,
  REQUEST_OTP_SUCCESS,
  REQUEST_OTP_ERROR,
  RESET_OTP_REQUEST,
  SETTING_MPIN,
  SETTING_MPIN_SUCCESS,
  SETTING_MPIN_ERROR,
  RESET_SESSION,
  TOKEN_AUTHENTICATE,
  TOGGLE_SIGNUP_DLG,
  FETCH_SESSION_ID_SUCCESS,
} from "../actions/types";
import { getCookie } from "../utils";

const initialState = {
  sessionId: '',
  sessionChecked: false,
  error: null,
  authenticating: false,
  otpSendStatus: false, // Don't restore from cookies - only set after actual OTP request
  settingMpin: false,
  signupDlg: false,
};

export const authReducer = (
  state: typeof initialState = initialState,
  action: Action
): typeof initialState => {
  const { type, payload } = action;
  switch (type) {
    case INITIATE_LOGIN:
    case TOKEN_AUTHENTICATE:
      return {
        ...state,
        sessionId: '',
        sessionChecked: false,
        authenticating: true,
        error: null,
      };

    case LOGIN_SUCCESS:
      return {
        ...state,
        sessionId: payload,
        sessionChecked: true,
        authenticating: false,
        error: null,
        signupDlg: false,
      };

    case LOGIN_ERROR:
      return {
        ...state,
        sessionId: '',
        authenticating: false,
        error: payload
      };

    case SESSION_CHECKED_SUCCESS:
      return {
        ...state,
        sessionChecked: true,
        error: null
      };

    case RESET_CHECK_SESSION:
      return {
        ...state,
        sessionChecked: false
      };

    case SESSION_CHECKED_ERROR:
      return {
        ...state,
        sessionId: '',
        sessionChecked: true,
        error: payload
      };
    
    case SET_SESSION_ID:
      return {
        ...state,
        sessionId: payload,
      };

    case INITIATE_REQUEST_OTP:
      return {
        ...state,
        authenticating: true,
      }

    case REQUEST_OTP_SUCCESS:
      return {
        ...state,
        authenticating: false,
        otpSendStatus: true,
      }

    case REQUEST_OTP_ERROR:
      return {
        ...state,
        authenticating: false,
        otpSendStatus: false,
        error: payload
      }

    case RESET_OTP_REQUEST:
      return {
        ...state,
        otpSendStatus: false,
      }

    case SETTING_MPIN:
      return {
        ...state,
        settingMpin: true,
      }

    case SETTING_MPIN_SUCCESS:
      return {
        ...state,
        settingMpin: false,
      }

    case SETTING_MPIN_ERROR:
      return {
        ...state,
        settingMpin: false,
        error: payload,
      }

    case RESET_SESSION: 
      return {
        ...initialState
      }

    case TOGGLE_SIGNUP_DLG:
      return {
        ...state,
        signupDlg: payload
      }

    case FETCH_SESSION_ID_SUCCESS:
      return {
        ...state,
        ...payload,
      }

    default:
      return state;
  }
};
